"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemDetail = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const material_1 = require("@mui/material");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const ItemMainInfo_1 = __importDefault(require("./ItemMainInfo"));
const helpers_1 = require("../../../common/helpers/helpers");
const DocumentDetail_1 = __importDefault(require("./DocumentDetail"));
const WebsiteDetail_1 = __importDefault(require("./WebsiteDetail"));
const RecipeDetail_1 = __importDefault(require("./RecipeDetail"));
const ItemMedia_1 = __importDefault(require("./ItemMedia"));
const CallToActions_1 = __importDefault(require("./CallToActions"));
const ItemDetailWrapper = styled_components_1.default.div `
  background-color: #fff;
  height: 100%;
  width: 100%;
  overflow: auto;
  z-index: 10;
  margin-top: ${(props) => (props.addMarginTop ? "-56px" : "0")};
  padding-bottom: ${(props) => (props.isBookable ? "88px" : "0")};

  @media (min-width: 600px) {
    margin-top: ${(props) => (props.addMarginTop ? "-64px" : "0")};
  }
  @media (min-width: 768px) {
    padding-bottom: 0;
  }
  @media (min-width: 1024px) and (orientation: landscape) {
    margin-top: 0;
    height: 93.5vh;
    overflow: hidden;
  }
  ul {
    &:not(.browser-default) {
      padding-left: 40px;
      list-style-type: initial;

      & > li {
        list-style-type: initial;
      }
    }
  }
`;
const ItemContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  @media (min-width: 1024px) and (orientation: landscape) {
    flex-direction: row;
    height: 100%;
  }
`;
const ItemMainInfoWrapper = styled_components_1.default.div `
  flex-basis: 30%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .header {
    margin-top: 0;
  }
  @media (min-width: 1024px) and (orientation: landscape) {
    flex-basis: 50%;
    width: 50%;
    height: 100%;
    position: relative;
    order: 1;
  }
`;
const ItemText = styled_components_1.default.div `
  padding: 24px;
  background-color: #fff;
  color: #212121;
  word-break: break-word;
  overflow: auto;
  flex-basis: 50%;
  flex-grow: 1;
  a {
    pointer-events: "auto";
    color: "#039be5";
    display: inline-block;
  }
  @media (max-width: 500px) {
    padding: 0px 24px;
  }
`;
const MainCtaButtonWrapper = styled_components_1.default.div `
  position: fixed;
  bottom: 0;
  width: 100vw;
  padding: 16px;
  margin: 0 auto;
  background: #ffffff;
  text-align: center;
  box-shadow: 0px 0px 4px 0px rgb(0 0 0 / 75%);
  @media (min-width: 768px) {
    display: none;
  }
`;
const ItemDetail = (props) => {
    const { updateStore, activeItem, history, location } = props;
    const { content } = activeItem;
    const wrapperRef = (0, react_1.useRef)(null);
    const contentRef = (0, react_1.useRef)(null);
    const imageRef = (0, react_1.useRef)(null);
    const isRegularContent = content.type !== "recipe" &&
        content.type !== "website" &&
        content.type !== "document" &&
        content.type !== "folder";
    const isShoppingCart = isRegularContent
        ? !!content.shoppingCartCatalogId
        : false;
    const isBookable = isRegularContent && content.bookable && content.availability;
    const itemHasVideo = isRegularContent && content.videos && content.videos.length > 0;
    const addTargetAttributeToLinks = () => {
        if (contentRef && contentRef.current) {
            const links = contentRef.current.querySelectorAll("a");
            if (links.length > 0) {
                links.forEach((link) => {
                    link.setAttribute("target", "_blank");
                });
            }
        }
    };
    const handleScroll = () => {
        if (!helpers_1.Helpers.isInViewport(imageRef.current)) {
            // TODO avoid rerenders here if possible
            updateStore("isHeaderTransparent", false);
        }
        else {
            updateStore("isHeaderTransparent", true);
        }
    };
    const showBookingArea = () => {
        history.push({
            pathname: `${location.pathname}/${isShoppingCart ? "cart" : "book"}`,
            search: location.search,
        });
    };
    (0, react_1.useEffect)(() => {
        if (isRegularContent) {
            addTargetAttributeToLinks();
            if (!itemHasVideo) {
                updateStore("isHeaderTransparent", true);
                updateStore("hideLogo", true);
                if (wrapperRef && wrapperRef.current) {
                    wrapperRef.current.addEventListener("scroll", handleScroll, {
                        passive: true,
                    });
                }
            }
        }
        return () => {
            if (isRegularContent && !itemHasVideo) {
                updateStore("hideLogo", false);
                if (wrapperRef && wrapperRef.current) {
                    wrapperRef.current.removeEventListener("scroll", handleScroll, {
                        passive: true,
                    });
                }
            }
        };
    }, []);
    const renderMainCTAButton = () => {
        if (isBookable) {
            return (react_1.default.createElement(MainCtaButtonWrapper, null,
                react_1.default.createElement(material_1.Button, { size: "large", onClick: showBookingArea, variant: "contained", fullWidth: true }, content.availability.textsForDisplay.bookButton)));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    const renderActiveItem = () => {
        switch (content.type) {
            case "website":
                return react_1.default.createElement(WebsiteDetail_1.default, { websiteData: content });
            case "document":
                return react_1.default.createElement(DocumentDetail_1.default, { documentData: content });
            case "recipe":
                return react_1.default.createElement(RecipeDetail_1.default, { recipeData: content });
            default:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(ItemContent, { className: "item-upper-content" },
                        react_1.default.createElement(ItemMedia_1.default, { activeItem: activeItem, forwardedRef: imageRef }),
                        react_1.default.createElement(ItemMainInfoWrapper, { className: "item-detail-headline" },
                            react_1.default.createElement(ItemMainInfo_1.default, { content: {
                                    data: content,
                                    type: activeItem.type,
                                }, showBookingArea: showBookingArea }),
                            react_1.default.createElement(CallToActions_1.default, { activeItem: activeItem }),
                            react_1.default.createElement(ItemText, { className: "item-detail-text", ref: contentRef }, content.text && (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                                    __html: content.text,
                                } })))))));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ItemDetailWrapper, { id: "item-detail", itemType: activeItem.type, ref: wrapperRef, isBookable: isBookable, addMarginTop: isRegularContent && !itemHasVideo },
            renderActiveItem(),
            renderMainCTAButton())));
};
exports.ItemDetail = ItemDetail;
const mapStoreToProps = (store) => ({
    itemDetailIsShown: store.getValue("itemDetailIsShown"),
    pausedByInteraction: store.getValue("pausedByInteraction"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.ItemDetail));
